// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';

// import modules
import DefaultContainer from '../../modules/Containers/DefaultContainer';
import DefaultPageTitle from '../../modules/Containers/DefaultPageTitle';

import ImgMe from '../../assets/about-me.jpg';

export default function PageAbout() {
    const { t } = useTranslation('about', { keyPrefix: 'about' });

    return (
        <DefaultContainer>
            <Container>
                <Row>
                    <Col style={{ textAlign: 'center' }}>
                        <img src={ImgMe} style={{ paddingTop: 20 }} />
                    </Col>
                    <Col>
                        <DefaultPageTitle><div style={{ textAlign: 'right' }}> {t('title')}</div></DefaultPageTitle>
                        <div style={{ textAlign: 'right' }}>
                            <div dangerouslySetInnerHTML={{ __html: t('content', { interpolation: { escapeValue: false } }) }} />
                        </div>
                    </Col>
                </Row>
            </Container>

        </DefaultContainer>
    );
}
